import { Component } from '@angular/core';

@Component({
  selector: 'swb-products',
  templateUrl: './products.component.html'
})
export class ProductsComponent {

  public productsQuery = '';
  public categoriesQuery = '';
  public testimonialsQuery = '';

  public filterProducts(query: string): void {
    this.productsQuery = query;
  }

  public filterCategories(query: string): void {
    this.categoriesQuery = query;
  }

  public filterTestimonials(query: string): void {
    this.testimonialsQuery = query;
  }

}
